// JavaScript Document

jQuery(function(){
 var shrinkHeader = 30;
  jQuery(window).scroll(function() {
    var scroll = getCurrentScroll();
      if ( scroll >= shrinkHeader ) {
           jQuery('#top-bar-menu').addClass('shrink');
           jQuery('#minibar-menu').addClass('shrink');
        }
        else {
            jQuery('#top-bar-menu').removeClass('shrink');
            jQuery('#minibar-menu').removeClass('shrink');
        }
  });
function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
    }
});
